import dayjs from "dayjs";

import { createAsyncThunk } from "@reduxjs/toolkit";

import { NmckDataKeyEnum } from "../nmckSlice";

export const editNmckItem = createAsyncThunk("nmck/editNmckItem", async (_, { rejectWithValue, extra, getState }) => {
	const state = getState();
	const itemId = state.nmck.baseData.id;
	const editingData = state.nmck.editingData;
	const periods = state.nmck.periods;

	const getDateId = (date) => {
		return periods.find(({ date_start }) => date_start === dayjs(date).startOf("month").format("YYYY-MM-DD"))?.id;
	};

	try {
		const { data } = await extra.apiNmck.editItem({
			itemId,
			body: {
				nmck_type_id: editingData[NmckDataKeyEnum.TYPE].id,
				period_price_level_estimate_id: getDateId(editingData[NmckDataKeyEnum.PRICE_LEVEL_PERIOD]),
				period_nmck_creation_id: getDateId(editingData[NmckDataKeyEnum.CREATION_PERIOD]),
				period_building_start_id: getDateId(editingData[NmckDataKeyEnum.BUILDING_START_PERIOD]),
				period_building_end_id: getDateId(editingData[NmckDataKeyEnum.BUILDING_END_PERIOD]),
				suffix: editingData[NmckDataKeyEnum.SUFFIX],
				// reserv: Number.parseFloat(editingData[NmckDataKeyEnum.RESERV]),
				vat: Number.parseFloat(editingData[NmckDataKeyEnum.VAT]),
				methodic: editingData[NmckDataKeyEnum.METHODIC],
				count_ret_months: editingData[NmckDataKeyEnum.COUNT_RET_MONTHS],
				retintion_periods: editingData[NmckDataKeyEnum.RETENTION_PERIODS],
			},
		});

		if (!data) {
			throw new Error();
		}

		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
